import type { Metadata } from 'next';
import type { getTranslations } from 'next-intl/server';

export const openGraph = (
  t: Awaited<ReturnType<typeof getTranslations>>,
): Metadata['openGraph'] => {
  return {
    url: 'https://orders.ouraring.com',
    siteName: t('opengraph_site_name'),
    title: t('meta_data_home_title'),
    description: t('meta_data_home_description'),
    // Since BOP is not a public website, having open graph metadata isn't a huge deal, but nice to have
    images: {
      // open graph images need to be fully qualified, and next cannot seem to figure out the base URL at build time based on the public asset path prefix
      url: 'https://ouraring.com/assets/icons/opengraph-400x400.png',
      alt: 'Oura Ring',
      width: 400,
    },
  };
};
